module.exports = __webpack_public_path__ + "img/3.cab61997.jpg";